import ajax from '../BsAjax'
import bsGetCapis from '../BsGetcapis'
import {toast} from '../VnToast'
import bsUtil from '../BsUtil'
import BsGetLocation from '../BsGetLocation'

const code = bsUtil.queryString('code') || '';
let officialData = {
  code: code,
}
// 根据code，获取access_token、openid
async function getAccessToken(data) {
    let loaction = await BsGetLocation();
    return ajax.post(bsGetCapis + '/web/user/login/weiXin/accessToken', bsUtil.stringify(data), {
      ddcinfo: {
        identifier: 'welfarecenter.h5',
        latitude: loaction.latitude,
        longitude: loaction.longitude,
        location_time: bsUtil.nowTime()
      }
    })
  }
  // 获取用户信息
async function official(data) {
    let loaction = await BsGetLocation();
    return ajax.post(bsGetCapis + '/web/user/login/weiXin/official', bsUtil.stringify(data), {
      ddcinfo: {
        identifier: 'welfarecenter.h5',
        latitude: loaction.latitude,
        longitude: loaction.longitude,
        location_time: bsUtil.nowTime()
      }
    })
  }

async function getOffice(fn, data, phone, error, close, valitecode){
    if(!phone){
      officialData =  {
          openid: data.openId,
          accessToken: data.accessToken
      }
    } else {
      officialData.phone = phone
      officialData.code = valitecode
    }
    let off = await official(officialData).catch(()=>{
        toast('登录失败！')
        error();
    });
    if(off.data.code === 0){
        if (off.data.newUser === 1) {
            // 展示去登陆的输入框，绑定手机号
            fn({code: 1, newUser:true });
        } else {
            fn({
                cid: off.data.cid,
                access_token: off.data.access_token
              })
        }
        close && close();
    }else{
        toast('登录失败！')
        error();
    }
}



// 微信登录成功后自动登录
export default async function(fn, phone, error = ()=>{}, close, valitecode){
  async function goWeixin(url){
    if (!code) {
      const locationStr = url || window.location.origin + window.location.pathname + window.location.search
      const finalUri = encodeURIComponent(locationStr)
      const redirectUri = 'https://web.didachuxing.com/H5/Redirector?url=' + finalUri
      window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?${bsUtil.stringify({
        appid: 'wxf18a88f56d23da94',
        redirect_uri: redirectUri,
        response_type: 'code',
        scope: 'snsapi_userinfo',
        state: 'STATE'
      })}#wechat_redirect`)
    } else {
      const data = {
        appid: 'wxf18a88f56d23da94',
        secret: '721d6a48cdfc0635deecf42669252705',
        code: code,
        grant_type: 'authorization_code'
      }
      // 拿着code去获取用户状态，老用户返回cid和token
      await getAccessToken(data).then(async aton=>{
        if(aton.data.code === 0){
          await getOffice(fn, aton.data,  phone, error, close);
        }else if(aton.data.code === 1741){
          code = ''
          goWeixin(location.href.replace(/code=[^&]*/g,'').replace("&&", "&"))
        }else{
          error();
        }
      }).catch((e)=>{
          toast('登录失败！');
          error();
      });
    }
  }
  if(phone){
    await getOffice(fn, {} , phone, error, close, valitecode);
    return;
  }
  goWeixin()
}
